import styled from "styled-components";
import { motion } from "framer-motion/dist/framer-motion";

export const MainTopCollections = styled.div`
  overflow: hidden;
`;

export const CollectionsHeading = styled(motion.h2)`
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #1a1a1a;
  margin-top: 80px;
  margin-left: 9rem;

  @media (max-width: 1199.98px) {
    margin-left: 2rem;
  }

  @media (max-width: 575.98px) {
    margin-left: 0rem;
    text-align: center;
  }
`;

export const CollectionsTable = styled(motion.div)`
  padding: 0px 130px;
  margin-top: 60px;

  @media (max-width: 1199.98px) {
    padding: 0px 30px;
  }
  @media (max-width: 575.98px) {
    margin-top: 20px;
  }

  .img-fluid {
    margin-left: 10px;
    margin-bottom: 3px;
  }

  .css-11xur9t-MuiPaper-root-MuiTableContainer-root {
    box-shadow: none;
  }

  .css-1ygcj2i-MuiTableCell-root {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    border-bottom: 1px solid #f2f2f2;
  }

  .css-1azl6jz-MuiTableCell-root {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;
  }

  .css-1ex1afd-MuiTableCell-root {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;

    p {
      cursor: pointer;
    }

    input {
      height: 21px;
      width: 24px;
      margin-right: 15px;
      transform: translateY(4px);
    }
  }

  .css-177gid-MuiTableCell-root {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    color: #000000;
    padding: 25px 0px;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;

    .img-fluid {
      margin-right: 5px;
    }

    span {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 23px;
      color: #d35400;
      margin-left: 20px;
    }
  }
`;

export const BtnContainer = styled.div`
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 575.98px) {
    margin-top: 40px;
  }

  a {
    text-decoration: none;
  }
`;
